import "./App.css";
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import LandingPage from "./Pages/LandingPage/LandingPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import ForgetPassword from "./Pages/ForgetPassword/ForgetPassword";
import AdminLogin from "./Pages/AdminLogin";
import TermsCondition from "./Pages/TermsConditions/TermsCondition";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Login from "./Pages/Login/Login";
import SplashScreen from "./Components/SplashScreen/SplashScreen";
import ContractInteraction from "./Pages/Page";
import axios from "axios";
import { setUserPersonalInfo } from "./Redux/ProfileDataSlice";
import { Toaster } from "react-hot-toast";
import { setAuthToken } from "./Redux/StatusState";
import Register from "./Pages/Register/Register";
import VerifyEmail from "./Pages/VerifyEmail/VerifyEmail";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const sponsor = urlParams.get("ref") || urlParams.get("start_param");
  const basepath = process.env.REACT_APP_API_URL;

  if (process.env.NODE_ENV === "production") {
    console.log = () => { };
    console.error = () => { };
    console.warn = () => { };
    console.info = () => { };
    console.debug = () => { };
  }

  useEffect(() => {
    const checkAuth = async () => {
      // Direct login token (from admin)
      if (token && token.length > 10) {
        try {
          const response = await axios.get(`${basepath}/get_profile`, {
            headers: { Authorization: token },
          });

          if (response) {
            localStorage.setItem("token", token);
            localStorage.setItem("userId", response?.data?.uid);
            dispatch(setAuthToken(token));
            dispatch(setUserPersonalInfo(response?.data?.user));
            navigate("/");
          }
        } catch (err) {
          console.log("get_profile error, token might be invalid", err);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, [token, navigate, dispatch]);

  const isLoggedIn = !!localStorage.getItem("token");

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route
          path="/*"
          element={
            loading ? (
              <SplashScreen />
            ) : isLoggedIn ? (
              <LandingPage />
            ) : (
              <Navigate
                to={sponsor ? `/register?ref=${sponsor}` : "/login"}
                replace
              />
            )
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forget_password" element={<ForgetPassword />} />
        <Route path="/admin_login" element={<AdminLogin />} />
        <Route path="/terms_conditions" element={<TermsCondition />} />
        <Route path="/test" element={<ContractInteraction />} />
      </Routes>
    </>
  );
}

export default function Root() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
